import { Builder, builder } from '@builder.io/react';

builder.init('69fac0673d2644f0a0a962e1cb3045ef');

/**
 * Trim response data. Helps with page bloat
 * @param {Object} data Builder.io data returned from builder.get('navbar')
 * @returns {Object} simplified object with only rendering data for nav.
 */
export function cleanNavData(data) {
  return {
    navItems: data?.navItems,
    // legacy compatibility with desktop-user-nav-popover.jsx.
    // current implementation only uses userNavItems when a user is signed in
    // based on diff builder.io entries for signed out/signe in nav
    userNavItems: data?.userNavItems?.map(route => ({...route, type: 'signed-in'})),
    logoLink: data?.logoLink,
    buttonSection: data?.buttonSection?.value?.data?.blocks,
    previewUserLoggedIn: data?.previewUserLoggedIn,
  };
}

// eslint-disable-next-line import/prefer-default-export
export async function getNavbar(opts = {}) {
  const { loggedIn = false, hasMachine = false } = opts;
  const links = await builder
    .get('navbar', {
      includeRefs: true,
      preview: Builder.isPreviewing || Builder.isEditing,
      // You can use options for queries, sorting, and targeting here
      // https://github.com/BuilderIO/builder/blob/main/packages/core/docs/interfaces/GetContentOptions.md
      userAttributes: Builder.isEditing ? undefined : {
        loggedIn,
        hasMachine,
      },
    })
    .promise();

  return cleanNavData(links?.data);
}
